import { Component } from 'react';
import Raven from 'raven-js';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      errorInfo: null
    };
  }
  componentDidCatch(error, errorInfo) {
    var _this$props$onError, _this$props;
    this.setState({
      error,
      errorInfo
    });
    Raven.captureException(error, {
      extra: {
        errorInfo
      },
      level: 'critical'
    });
    (_this$props$onError = (_this$props = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props, error, errorInfo);
  }
  render() {
    const {
      error
    } = this.state;
    if (error) {
      return /*#__PURE__*/_jsx(ErrorMessage, {
        children: /*#__PURE__*/_jsx("p", {
          children: error.toString()
        })
      });
    }
    return this.props.children;
  }
}
export default ErrorBoundary;